module.exports = __webpack_public_path__ + "static/media/unmute_notification.f47e6c46.svg";